var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MasterDetail',{ref:"detail",attrs:{"actionBarButtons":_vm.actionBarButtons,"hasNewButton":false,"canEdit":false,"contextOptions":_vm.contextMenu,"disableActContextOnClick":true,"cols":_vm.cols,"customResource":_vm.customResource}})}
var staticRenderFns = []

export { render, staticRenderFns }